module.exports = __webpack_public_path__ + "static/media/css3.2fa97ca8.svg";